import { errorMessages } from "@config/errorMessages";

function extractApiName(url: string | undefined): string | undefined {
  if (!url) return undefined;
  const pathParts = url.split("?")[0].split(".net").filter(Boolean);
  return pathParts[pathParts.length - 1];
}

const matchPattern = (pattern: string, actualPath: string): boolean => {
  const patternParts = pattern.split("/").filter(Boolean);
  const actualParts = actualPath.split("/").filter(Boolean);
  return patternParts.every((part, i) => {
    return part.startsWith(":") || part === actualParts[i];
  });
};

export function getUserFriendlyError(error: any): string {
  const status = error?.response?.status;
  const errorKey = error?.response?.data?.error;
  const url = error?.response?.config?.url;
  const apiName = extractApiName(url);

  const errorGroup = errorMessages[status];
  if (!errorGroup) return "Oops! Something went wrong. We’re unable to process your request right now. Please try again later";

  if (typeof errorGroup === "string") return errorGroup;

  const messageEntry = errorGroup[errorKey];
  if (typeof messageEntry === "string") {
    return messageEntry;
  }

  if (typeof messageEntry === "object" && apiName) {
    for (const pattern of Object.keys(messageEntry)) {
      if (matchPattern(pattern, apiName)) {
        return messageEntry[pattern];
      }
    }
  }

  return "Oops! Something went wrong. We’re unable to process your request right now. Please try again later";
}
